import React from "react";
import {  FaCoffee } from 'react-icons/fa';

const BuyMeCoffeeButton: React.FC = () => {
  return (
    <a
      href="https://buymeacoffee.com/sumithalge"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 16px",
        backgroundColor: "#ffffffff",
        color: "#000",
        borderRadius: "6px",
        fontWeight: "bold",
        textDecoration: "none",
        cursor: "pointer",

      }}
    >
      Buy Me a Chai˗ˏˋ☕ˎˊ˗ 
    </a>
  );
};

export default BuyMeCoffeeButton;
